import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { ChevronDownIcon } from 'src/assets/icons/ChevronDownIcon';

export const SelectWrapper = styled('div', { label: 'SelectWrapper' })`
    position: relative;
    flex: 1 1 auto;
`;

export const DropdownWrapper = styled('select', { label: 'DropdownWrapper' })`
    appearance: none;
    background-color: ${mainColors.default.light};
    border: solid 1px ${mainColors.grays.gray400};
    border-radius: 4px;
    color: ${mainColors.main.primary};
    font-size: 12px;
    opacity: 0.64;
    padding: 8px 30px 8px 8px;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;

    :focus {
        opacity: 1;
    }
`;

export const ChevronDownWrapper = styled(ChevronDownIcon, { label: 'ChevronDownWrapper' })`
    fill: ${mainColors.main.primary};
    margin: 13px 8px;
    right: 11px;
    position: absolute;
    pointer-events: none;
`;
